module.exports = __webpack_public_path__ + "static/media/Professionnel.20b8ec38.jpg";